<script lang="ts">
	$effect(() => {
		const script: HTMLScriptElement = (window as any).document.createElement('script');
		(window as any).document.querySelector('head').appendChild(script);

		script.setAttribute('defer', '');
		script.setAttribute('src', 'https://smartcaptcha.cloud.yandex.ru/captcha.js');

		return () => {
			script.remove();
		};
	});

	let isSended = $state(false);
	let errorMessage = $state('');
	let selectedFileName = $state('');

	function handleFileChange(event: Event) {
		const input = event.currentTarget as HTMLInputElement;
		selectedFileName = input.files?.[0]?.name ?? '';
	}

	function onsubmit(e) {
		e.preventDefault();
		errorMessage = '';

		// fetch('https://m-pcb-new/api/feedback', {
		// fetch('http://localhost:5173/api/feedback', {
		fetch('https://www.woer.ru/api/feedback', {
			method: 'post',
			credentials: 'same-origin',
			redirect: 'follow',
			mode: 'cors',
			body: new FormData(e.currentTarget)
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}

				return Promise.reject('error');
			})
			.then(() => {
				isSended = true;
			})
			.catch((error) => {
				console.log('error', error);
				errorMessage = 'Ошибка отправки данных';
			});
	}
</script>

<div class="container">
	<section class="feedback-form">
		<h3 id="form-feedback">Отправьте запрос, получите консультацию специалиста и лучшее решение</h3>

		<div class="feedback-form__panel">
			<form method="POST" {onsubmit}>
				<div class="feedback-form__grid">
					<label class="feedback-form__field">
						<input name="name" placeholder="ФИО" required />
						<span class="feedback-form__required">Обязательное поле</span>
					</label>

					<label class="feedback-form__field">
						<input name="email" type="email" placeholder="Адрес электронной почты" required />
						<span class="feedback-form__required">Обязательное поле</span>
					</label>

					<label class="feedback-form__field">
						<input name="company" placeholder="Название компании" />
					</label>

					<label class="feedback-form__field">
						<input name="phone" type="tel" placeholder="Телефон для связи" required />
						<span class="feedback-form__required">Обязательное поле</span>
					</label>
				</div>

				<label class="feedback-form__message">
					<textarea name="description" placeholder="Технические требования или заявка / запрос"
					></textarea>
				</label>

				<div class="feedback-form__bottom">
					<div class="feedback-form__file-block">
						<label class="feedback-form__upload">
							<span>Загрузить файл проекта<br />и / или бланк заказа</span>
							<input
								type="file"
								name="card_file"
								accept=".zip,.rar,.doc,.docx,.jpg,.jpeg,.xls,.xlsx,application/zip,application/x-rar-compressed,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
								onchange={handleFileChange}
							/>
						</label>

						<div class="feedback-form__file-meta">
							<p>разрешенные типы файлов: .zip, .rar, .doc, .docx, .jpg, .xls</p>
							{#if selectedFileName}
								<p class="feedback-form__file-name">{selectedFileName}</p>
							{/if}
						</div>
					</div>

					<button class="feedback-form__submit" type="submit">ОТПРАВИТЬ</button>
				</div>

				<div
					id="captcha-container"
					class="smart-captcha"
					data-sitekey="ysc1_IqbAVngS1LI9yoh7fucifCyh6yNcKQbMxEJzLy3v6602f861"
				></div>

				<p class="feedback-form__note">
					* Нажимая кнопку «Отправить» Вы даете согласие на обработку персональных данных и
					соглашаетесь с <a
						href="/images/files/soglasie-na-obrabotku-personaljnyh-dannyh-m-pcb.pdf"
						target="_blank">политикой конфиденциальности.</a
					>
				</p>

				{#if errorMessage}
					<div class="feedback-form__error">{errorMessage}</div>
				{/if}
			</form>

			{#if isSended}
				<div class="feedback-form__success">Данные отправлены</div>
			{/if}
		</div>
	</section>
</div>

<style lang="sass">
=visually-hidden ()
	position: absolute
	width: 1px
	height: 1px
	padding: 0
	margin: -1px
	overflow: hidden
	clip: rect(0, 0, 0, 0)
	white-space: nowrap
	border: 0

:global
	#form-feedback
		margin: 0 0 0.875rem
		font-size: clamp(1.65rem, 2.8vw, 2.35rem)
		font-weight: 700
		line-height: 1.2
		text-align: center
		color: #3c3c3c

	.feedback-form
		margin: 0 auto 2rem

	.feedback-form__panel
		position: relative
		padding: 1.5rem 1.45rem 1.1rem
		border: 2px dashed #737373
		background: #fff

	.feedback-form__grid
		display: grid
		grid-template-columns: repeat(2, minmax(0, 1fr))
		gap: 1rem 2rem
		margin-bottom: 0.95rem

	.feedback-form__field,
	.feedback-form__message
		position: relative
		display: block

	.feedback-form__field input,
	.feedback-form__message textarea
		width: 100%
		border: 3px solid #0d7a45
		border-radius: 14px
		background: #fff
		color: #4c4c4c
		font-size: 1.3rem
		font-weight: 600
		transition: border-color 0.2s ease, box-shadow 0.2s ease

		&::placeholder
			color: #787878
			opacity: 1

		&:focus
			outline: none
			border-color: #085a31
			box-shadow: 0 0 0 3px rgba(13, 122, 69, 0.12)

		&:invalid:focus
			border-color: #d94141
			box-shadow: 0 0 0 3px rgba(217, 65, 65, 0.12)

	.feedback-form__field input
		height: 3.25rem
		padding: 0.75rem 8.8rem 0.75rem 1rem

	.feedback-form__required
		position: absolute
		top: 50%
		right: 1rem
		transform: translateY(-50%)
		font-size: 1.08rem
		font-style: italic
		color: #ff2d2d
		pointer-events: none

	.feedback-form__message
		margin-bottom: 0.9rem

	.feedback-form__message textarea
		min-height: 8.5rem
		padding: 0.85rem 1rem
		resize: vertical

	.feedback-form__bottom
		display: flex
		align-items: flex-start
		justify-content: space-between
		gap: 1.5rem
		margin-bottom: 1rem

	.feedback-form__file-block
		display: flex
		align-items: center
		gap: 0.9rem
		flex: 1 1 auto
		min-width: 0

	.feedback-form__upload
		display: inline-flex
		align-items: center
		justify-content: center
		min-width: 14.8rem
		min-height: 3.25rem
		padding: 0.45rem 1rem
		border: 3px solid #0d7a45
		border-radius: 14px
		background: #fff
		color: #666
		font-size: 1.25rem
		font-weight: 700
		line-height: 1.1
		text-align: center
		cursor: pointer

		input
			@include visually-hidden()

	.feedback-form__file-meta
		max-width: 21rem
		font-size: 1.15rem
		line-height: 1.2
		color: #3c3c3c

		p
			margin: 0

	.feedback-form__file-name
		margin-top: 0.35rem !important
		color: #0d7a45
		font-weight: 700
		word-break: break-word

	.feedback-form__submit
		flex: 0 0 auto
		min-width: 10rem
		min-height: 3.25rem
		padding: 0.45rem 1.25rem
		border: 0
		border-radius: 14px
		background: #0d7a45
		color: #fff
		font-size: 1.55rem
		font-weight: 800
		cursor: pointer
		transition: background-color 0.2s ease, transform 0.2s ease

		&:hover
			background: #0a6338

		&:focus
			outline: none
			box-shadow: 0 0 0 3px rgba(13, 122, 69, 0.18)

		&:active
			transform: translateY(1px)

	.smart-captcha
		display: flex
		justify-content: center
		margin: 0.25rem 0 0.75rem
		transform: scale(0.7)
		transform-origin: center top
		width: 135%
		margin-left: -17%

	.feedback-form__note
		margin: 0
		font-size: 1.08rem
		line-height: 1.2
		font-style: italic
		color: #323232

		a
			color: #0d7a45
			font-weight: 700
			text-decoration: none

			&:hover
				text-decoration: underline

	.feedback-form__error
		margin-top: 0.75rem
		color: #d94141
		font-weight: 700

	.feedback-form__success
		position: absolute
		inset: 0
		display: flex
		align-items: center
		justify-content: center
		padding: 1.5rem
		background: rgba(255, 255, 255, 0.82)
		backdrop-filter: blur(4px)
		color: #0d7a45
		font-size: clamp(1.4rem, 3vw, 2.4rem)
		font-weight: 800
		text-align: center

	@media (max-width: 991px)
		.feedback-form__grid
			grid-template-columns: 1fr
			gap: 0.9rem

		.feedback-form__bottom
			flex-direction: column
			align-items: stretch

		.feedback-form__file-block
			flex-direction: column
			align-items: stretch

		.feedback-form__file-meta
			max-width: none

		.feedback-form__submit
			width: 100%

	@media (max-width: 640px)
		.feedback-form__panel
			padding: 1rem

		.feedback-form__field input
			padding-right: 1rem
			height: 3.1rem

		.feedback-form__required
			position: static
			display: block
			margin-top: 0.35rem
			transform: none
			text-align: right

		.feedback-form__upload
			width: 100%
			min-width: 0
</style>
